var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add-Disabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MOCKS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart---M---Shop---1-Product-Copy-13",
    transform: "translate(-164.000000, -221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Disabled",
    transform: "translate(164.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    fill: "#D0D0D0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3-Copy",
    cx: 10,
    cy: 10,
    r: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4062374,15 C10.5184617,15 10.6093619,14.9090998 10.6093619,14.7968755 L10.6093619,10.7343852 L14.6718522,10.7343852 C14.7840765,10.7343852 14.8749768,10.643485 14.8749768,10.5312607 L14.8749768,9.71876259 C14.8749768,9.60653828 14.7840765,9.51563808 14.6718522,9.51563808 L10.6093619,9.51563808 L10.6093619,5.45314776 C10.6093619,5.34092345 10.5184617,5.25002325 10.4062374,5.25002325 L9.59373935,5.25002325 C9.48151503,5.25002325 9.39061483,5.34092345 9.39061483,5.45314776 L9.39061483,9.51563808 L5.32812452,9.51563808 C5.2159002,9.51563808 5.125,9.60653828 5.125,9.71876259 L5.125,10.5312607 C5.125,10.643485 5.2159002,10.7343852 5.32812452,10.7343852 L9.39061483,10.7343852 L9.39061483,14.7968755 C9.39061483,14.9090998 9.48151503,15 9.59373935,15 L10.4062374,15 Z",
    id: "p",
    fill: "#ECECEC",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDisabled);
export default __webpack_public_path__ + "static/media/add-disabled.02ce14ff6a2287ec68f9c0388fcf607c.svg";
export { ForwardRef as ReactComponent };